module.exports = __webpack_public_path__ + "img/ControlArrow1.292ee399.svg";